// @ts-nocheck

export const localeCodes =  [
  "en",
  "lo",
  "ms",
  "th",
  "vi",
  "zh-hans",
  "zh-hant"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_df5b95ae",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  lo: [
    {
      key: "locale_lo_46json_b979ad0a",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ms: [
    {
      key: "locale_ms_46json_aced5feb",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  th: [
    {
      key: "locale_th_46json_d232eb8e",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  vi: [
    {
      key: "locale_vi_46json_74ac0d11",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  "zh-hans": [
    {
      key: "locale_zh_45hans_46json_bdc5684f",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  "zh-hant": [
    {
      key: "locale_zh_45hant_46json_678856fa",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/268be875" /* webpackChunkName: "config_i18n_46config_46ts_268be875" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    label: "English",
    icon: "emojione:flag-for-united-states",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "lo",
    language: "lo",
    label: "ພາສາລາວ",
    icon: "emojione:flag-for-laos",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ms",
    language: "ms",
    label: "Malay",
    icon: "emojione:flag-for-malaysia",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "th",
    language: "th",
    label: "ภาษาไทย",
    icon: "emojione:flag-for-thailand",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "vi",
    language: "vi",
    label: "Tiếng Việt",
    icon: "emojione:flag-for-vietnam",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "zh-hans",
    language: "zh-hans",
    label: "简体中文",
    icon: "emojione:flag-for-china",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "zh-hant",
    language: "zh-hant",
    label: "繁體中文",
    icon: "emojione:flag-for-hong-kong-sar-china",
    domains: [],
    defaultForDomains: []
  }
]

